module.exports = __webpack_public_path__ + "cancellara-dist/img/hero-landing-default.b03f6fa6.jpg";